import { ResponseResultTypeDecorator } from '../../public-api';
import { SnapShotFrameItem } from '../domain-models/snap-shot-frame-item';
import { GenericArrayServiceResponse } from './generic-array-service-response';

@ResponseResultTypeDecorator(SnapShotFrameItem)
export class GetSnapShotFrameListResponse extends GenericArrayServiceResponse<SnapShotFrameItem> {

}
